module.exports = __webpack_public_path__ + "static/media/th1_level_2.5e1db3fd.png";